import { laravelAxios } from '../../../../config/axios/laravelAxios';

async function renewToken() {
  return laravelAxios.post('crm/renew-token');
}

export default renewToken;
